import { useState } from "react";
import clsx from "clsx";
import { UploadIcon } from "lucide-react";

import { CreateJobFileDialog } from "./CreateJobFileDialog";
import { JobFilesTable } from "./JobFilesTable";
import { Column, EmptyState } from "@/components";
import { Button } from "@/components/ui/button";

import { useGetJobFiles } from "@/hooks/queries/useGetJobFiles";

export const JobFiles = ({ className }: { className?: string }) => {
  const { data: jobFiles, status } = useGetJobFiles();
  const [isCreateJobFileDialogOpen, setIsCreateJobFileDialogOpen] =
    useState(false);

  if (status === "pending") {
    // TODO: Loading state.
    return null;
  } else if (status === "error") {
    // TODO: Error state.
    return null;
  }

  return (
    <Column className={clsx("items-end gap-6", className)}>
      {jobFiles.length > 0 ? (
        <>
          <Button
            className="rounded-full"
            onClick={() => {
              setIsCreateJobFileDialogOpen(true);
            }}
          >
            <UploadIcon className="h-4 w-4" />
            Upload file
          </Button>
          <JobFilesTable className="w-full" jobFiles={jobFiles} />
        </>
      ) : (
        <EmptyState
          description="Files uploaded to this job will appear here."
          handlePrimaryClick={() => {
            setIsCreateJobFileDialogOpen(true);
          }}
          Icon={UploadIcon}
          PrimaryButtonIcon={UploadIcon}
          primaryButtonName="Upload file"
          primaryButtonVariant="default"
          title="Upload a file"
        />
      )}
      <CreateJobFileDialog
        onOpenChange={setIsCreateJobFileDialogOpen}
        onSuccess={() => {
          setIsCreateJobFileDialogOpen(false);
        }}
        open={isCreateJobFileDialogOpen}
      />
    </Column>
  );
};
